import { Injectable } from '@angular/core';

import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { BioCatchService } from '../external/biocatch/biocatch.service';
import { RequestService } from '../request/request-onboarding.service';

@Injectable({
  providedIn: 'root',
})
export class SignOnService {

  constructor(
    private requestService: RequestService,
    private bioCatchService: BioCatchService,
    private abreCuentasService: AbreCuentasService) { }

  /**
   * Validación de aceptación de términos y condiciones, registro en la bítacora
   *
   * *Terms and conditions acceptance validation*
   */
  async termsAndConditions(): Promise<any> {
    try {
      const deviceInfo = this.abreCuentasService.getDeviceInfo();
      const transactionInfo = this.abreCuentasService.getTransactionInfo();
      const ipBiocatch = this.bioCatchService.getCurrentScoreIp();
      if (deviceInfo !== undefined && deviceInfo !== null) {
        const body = {
          device: {
            ...deviceInfo,
            ip: ipBiocatch,
          },
          terms_type: 'product_terms',
          transaction: {
            ...transactionInfo,
            transaction_type: 'onboarding-angular-fe',
          },

        };
        return this.requestService.saveDataInBitacora(body);
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Función asíncrona para enviar la información de configuración
   *
   * *Async Function that sends config*
   *
   * @type {function}
   * @returns {Promise}
   */
  async createCasePerformSolicitation(body: any, solicitationId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService.createCasePerformSolicitation(body, solicitationId)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función asíncrona para enviar la información de configuración
   *
   * *Async Function that sends config*
   *
   * @type {function}
   * @returns {Promise}
   */
  async getCaseSolicitationInfo(solicitationId: string, productType: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService.getCaseSolicitationInfo(solicitationId, productType)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

}
